import React from 'react'
import Layout from '../../Layout/Layout'
import UserData from './UserData'

const UserReport = () => {
  return (
    <Layout>
      <UserData/>
    </Layout>
  )
}

export default UserReport
